
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.654 2.57C9.374 1.155 3.944 4.192 2.548 9.394 1.143 14.63 4.407 19.62 9.572 21.337a.893.893 0 00.043.013c.13.035.258.072.385.108h.001c.837.239 1.621.462 3.03.203 1.877-.347 3.014-1.606 3.342-3.075a4.268 4.268 0 00-1.34-4.1c-.498-.442-.657-.82-.685-1.065a.67.67 0 01.219-.587c.344-.325 1.21-.544 2.24.135 1.315.867 2.572 1.106 3.569.594.987-.508 1.402-1.592 1.402-2.646 0-3.836-3.176-7.291-7.124-8.348zM3.997 9.781c1.173-4.37 5.759-6.97 10.268-5.764 3.45.923 6.013 3.892 6.013 6.9 0 .723-.277 1.151-.588 1.311-.302.155-.95.218-2.057-.512-1.467-.967-3.13-.885-4.096.027a2.169 2.169 0 00-.68 1.847c.082.715.493 1.408 1.181 2.017a2.769 2.769 0 01.87 2.652c-.197.887-.868 1.69-2.148 1.926-1.054.194-1.539.057-2.33-.166-.126-.036-.26-.074-.404-.113-4.536-1.518-7.19-5.794-6.029-10.125zm7.19 9.232a1.376 1.376 0 10-.001-2.752 1.376 1.376 0 00.002 2.752zm-3.433-7.7A1.377 1.377 0 115 11.312a1.377 1.377 0 012.753.002zm1.236-2.85a1.376 1.376 0 10-.002-2.752 1.376 1.376 0 00.002 2.752zm6.267-2.212a1.375 1.375 0 11-2.751.001 1.375 1.375 0 012.751 0zm2.25 4.38a1.376 1.376 0 10-.002-2.751 1.376 1.376 0 00.001 2.751z"}})])
          )
        }
      }
    